import React from 'react';
import styled from 'styled-components';
import SwipeableDrawerComponent from '@commoncomponents/frontend-components/dist/components/SwipeableDrawer';
import * as Button from '@commoncomponents/frontend-components/dist/components/Buttons';
import { IconClose } from '@commoncomponents/frontend-components/dist/components/Icons/Icons';
import { colors } from '@commoncomponents/frontend-components/dist/styled';
import ActivationCodeInput from '../ActivationCodeInput';
import InfoBox from '../InfoBox';
import Warning from '../Warning';
const CodeInputBar = ({ open, translations, codeErrorMessage, newPlanInfoMessage, buttonDisabled, isProcessing, onCodeInputChange, onActivateClick, onClose, planChangeWarning, }) => {
    return (React.createElement(SwipeableDrawerComponent, { open: open, onOpen: () => { }, transitionDuration: 200, onClose: onClose },
        React.createElement(Wrapper, null,
            React.createElement(CloseIconWrapper, { onClick: onClose },
                React.createElement(IconClose, { color: colors.rockyGrey })),
            React.createElement(ActivationCodeInput, { label: translations.enterCodeInputLabel, onChange: onCodeInputChange, errorMessage: codeErrorMessage, infoMessage: newPlanInfoMessage, autoFocus: true }),
            React.createElement(InfoBox, { header: translations.consumerRightsHeader, text: translations.consumerRightsText }),
            planChangeWarning && React.createElement(Warning, { message: planChangeWarning }),
            React.createElement(Button.PrimaryRounded, { onClick: onActivateClick, label: planChangeWarning
                    ? translations.activateAnywayButtonText
                    : translations.buttonLabel, disabled: buttonDisabled, isProcessing: !buttonDisabled && isProcessing, fullWidth: true }))));
};
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;

  .info-box {
    padding: 16px 0;
  }
`;
const CloseIconWrapper = styled.div `
  align-self: flex-end;
  cursor: pointer;
  z-index: 1001;
`;
export default CodeInputBar;
